import React, { useState } from 'react';
import { ListDialects } from '../../CMFW/layout/ListDialects';
import styled from 'styled-components';
import { IRefIds } from '../../constants/refs';
import { FormControlLabel, Switch } from '@material-ui/core';
import TranslationsDialect from './TranslationsDialect';

type IProps = {
  keyName: string;
  refId: IRefIds;
  memory?: boolean;
  search?: boolean;
};

const Translations: React.FC<IProps> = ({ keyName, refId, memory = true, search = true }) => {
  const [useHTMLSourceEditor, setUseHTMLSourceEditor] = useState(true);

  const handleChangeUseHTMLSourceEditor = () => {
    setUseHTMLSourceEditor(!useHTMLSourceEditor);
  };

  const hasHTMLSourceEditor = (): boolean => {
    switch (refId) {
      case IRefIds.lessonTitle:
      case IRefIds.panelTitle:
      case IRefIds.tableLiterals:
      case IRefIds.cultural:
      case IRefIds.paragraph:
      case IRefIds.pronunciationExplanation:
      case IRefIds.trainer:
      case IRefIds.klines:
      case IRefIds.panelIntro:
      case IRefIds.heading:
      case IRefIds.bankKLine:
      case IRefIds.bankLessonTitle:
      case IRefIds.bankParagraph:
      case IRefIds.bankPanelIntro:
      case IRefIds.bankTableLiteral:
      case IRefIds.bankPanelTitle:
      case IRefIds.bankTrainerTitle:
        return true;
      default:
        return false;
    }
  };

  return (
    <Container>
      {hasHTMLSourceEditor() && (
        <FormControlLabelStyled
          control={
            <Switch
              checked={useHTMLSourceEditor}
              onChange={handleChangeUseHTMLSourceEditor}
              color="secondary"
              size="small"
            />
          }
          label={'CAT mode'}
        />
      )}
      <ListDialects keyName={keyName} key={refId}>
        <TranslationsDialect
          refId={refId}
          useHTMLSourceEditor={useHTMLSourceEditor}
          showMemory={memory}
          showSearch={search}
        />
      </ListDialects>
    </Container>
  );
};

export default Translations;

const Container = styled.div`
  margin-top: 20px;
`;

const FormControlLabelStyled = styled(FormControlLabel)`
  && {
    margin-left: 5px;
  }
`;
